import { scrollPageTo } from '../utils';
class Chapter {
	constructor(el) {
		// DOM elements
		this.el = el;

		// Status
		this.isOpen = false;

		// Event listeners
		this.el.addEventListener('click', this.toggle.bind(this));
		this.events = [];

		// Open based on query string (QR Code)
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		this.id = this.el.getAttribute('id');

		if (params.chapter) {
			if (params.chapter === this.id) {
				this.open();
				const elRect = this.el.getBoundingClientRect();
				const header = document.querySelector('.c-header-bar');
				scrollPageTo(window.pageYOffset + elRect.top - header.offsetHeight, 1000);
			}
		}
	}

	toggle(evt) {
		// Only toggle if not clicking on the button directly
		if (evt.target.closest('button')) {
			return;
		}
		this.isOpen ? this.close() : this.open();
	}

	open() {
		if (this.isOpen) {
			return;
		}

		this.el.classList.add('is-open');
		this.el.classList.add('is-active');
		this.dispatch('open');
		this.isOpen = true;
	}

	close() {
		if (!this.isOpen) {
			return;
		}

		this.el.classList.remove('is-open');
		this.el.classList.remove('is-active');
		this.dispatch('close');
		this.isOpen = false;
	}

	// Register events
	on(eventName, callback) {
		this.events.push({
			eventName,
			callback,
		});
	}

	dispatch(eventName) {
		const eventObjects = this.events.filter(event => event.eventName === eventName);

		if (!eventObjects) {
			return;
		}

		eventObjects.forEach(eventObject => {
			eventObject.callback(this);
		});
	}
}

export default class SoundtrackChapters {
	constructor(el) {
		this.chapters = el.querySelectorAll('[data-soundtrack-chapter');
		this.soundtrackChapters = new Map();

		this.chapters.forEach(chapter => {
			const soundtrackChapter = new Chapter(chapter);

			// When opening an entry, close other accordion chapters
			soundtrackChapter.on('open', chapter => {
				this.soundtrackChapters.forEach((instance, instanceEl) => {
					if (chapter.el !== instanceEl) {
						instance.close();
					}
				});
			});

			this.soundtrackChapters.set(chapter, soundtrackChapter);
		});
	}
}
